/*! Guide page FAQ — transforms h2 FAQ + h3/p pairs into theme accordions */
const PLUS_ICON_SVG = `<span class="icon icon--theme icon--plus"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 4L24 44M4 24.0024H44" vector-effect="non-scaling-stroke"></path></svg></span>`;

function isFaqHeading(el) {
  return el && el.tagName === "H2" && el.textContent.trim().toLowerCase() === "faq";
}

function isAnswerNode(el) {
  return el && (el.tagName === "P" || el.tagName === "UL" || el.tagName === "OL");
}

function collectFaqItems(faqHeading) {
  const items = [];
  let current = null;
  let node = faqHeading.nextElementSibling;

  while (node) {
    if (node.tagName === "H2") break;

    if (node.tagName === "H3") {
      if (current) items.push(current);
      current = { questionEl: node, answerNodes: [] };
    } else if (current && isAnswerNode(node)) {
      current.answerNodes.push(node);
    }

    node = node.nextElementSibling;
  }

  if (current) items.push(current);
  return items;
}

function buildAccordion(items, sectionId) {
  const wrapper = document.createElement("div");
  wrapper.className = "guide-page__faq faq__accordion";

  const group = document.createElement("accordion-group");
  group.setAttribute("single-open", "");

  items.forEach((item, index) => {
    const details = document.createElement("details");
    details.id = `guide-faq-${sectionId}-${index}`;

    const summary = document.createElement("summary");
    const question = document.createElement("span");
    question.className = "u-large";
    question.textContent = item.questionEl.textContent.trim();

    const summaryIcon = document.createElement("summary-icon");
    summaryIcon.innerHTML = PLUS_ICON_SVG;

    summary.append(question, summaryIcon);

    const detailsContent = document.createElement("details-content");
    const wrap = document.createElement("div");
    wrap.className = "faq__accordion__item-wrap rte";
    item.answerNodes.forEach((answerNode) => wrap.appendChild(answerNode));

    detailsContent.appendChild(wrap);
    details.append(summary, detailsContent);
    group.appendChild(details);
  });

  wrapper.appendChild(group);
  return wrapper;
}

function initGuideFaqAccordions() {
  document.querySelectorAll(".guide-page[data-section-id]").forEach((section) => {
    const body = section.querySelector(".guide-page__body");
    if (!body || body.dataset.faqEnhanced === "true") return;

    const faqHeading = Array.from(body.querySelectorAll("h2")).find(isFaqHeading);
    if (!faqHeading) return;

    const items = collectFaqItems(faqHeading);
    if (items.length === 0) return;

    const accordion = buildAccordion(items, section.dataset.sectionId);
    faqHeading.insertAdjacentElement("afterend", accordion);
    items.forEach((item) => item.questionEl.remove());
    body.dataset.faqEnhanced = "true";
  });
}

async function boot() {
  await customElements.whenDefined("accordion-group");
  initGuideFaqAccordions();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
